var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeactivatedSalesforce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 201,
    viewBox: "0 0 382 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3086_290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0761719 195.26H61.8738V185.664L67.8791 179.667",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2773 195.861H381.652",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.602 65.6602H293.2",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.207 65.0675H304.609C304.609 65.0675 307.811 54.2682 317.408 59.8669C317.408 59.8669 322.608 44.6716 341.005 47.8648C341.005 47.8648 350.602 53.0654 352.601 63.8648C352.601 63.8648 358.199 60.265 359.004 65.8637",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4482 118.741C37.3529 119.105 40.453 123.256 39.6907 127.101C41.1391 123.213 45.3402 120.528 49.4821 120.859",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8818 106.46C49.6341 107.426 53.4371 108.417 56.7913 110.356C60.1454 112.296 63.0422 115.345 63.9231 119.114C63.1354 116.531 64.5753 113.668 66.7267 112.033C68.8865 110.407 71.6224 109.772 74.282 109.323",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8701 91.2656V194.863",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.273 91.2656V194.863",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.458 123.266L318.661 148.464L317.458 195.659",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.46 171.663L342.656 172.866",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.257 158.865L318.262 182.065L338.26 162.863",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.461 172.467L303.458 166.462",
    stroke: "#666666",
    strokeWidth: 2.54102,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.059 149.267C336.261 148.869 350.254 151.266 350.254 151.266",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.659 151.665H304.261",
    stroke: "#666666",
    strokeWidth: 2.54102,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.461 142.068L319.059 165.268L348.661 137.266",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.657 130.862L307.057 138.468",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.062 126.864L329.859 138.866",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.058 132.87L318.661 148.464L296.664 129.271",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2803 165.666V194.066",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2765 172.467L46.4756 180.259",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4762 186.062L37.4805 178.464",
    stroke: "#666666",
    strokeWidth: 1.69401,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.813 2.19336H78.3397L53.5986 45.0349L78.3397 87.8765H127.813L152.546 45.0349L127.813 2.19336Z",
    stroke: "#666666",
    strokeWidth: 1.60533,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.018 5.29297H80.127L57.1816 45.0345L80.127 84.7761H126.018L148.963 45.0345L126.018 5.29297Z",
    fill: "#F8D6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.109 48.2082H89.8039V48.9961H85.2034V42.6569H89.6771V43.4448H86.109V45.3918H89.2877V46.1616H86.109V48.2082ZM95.0853 48.9961H94.0982L92.7127 47.1577L91.309 48.9961H90.34L92.2327 46.5419L90.4306 44.1964H91.3996L92.7217 45.9261L94.0349 44.1964H94.9857L93.1745 46.5419L95.0853 48.9961ZM98.5788 44.1512C99.9824 44.1512 101.006 45.1292 101.006 46.5963C101.006 48.0724 99.9824 49.0504 98.5788 49.0504C97.8996 49.0504 97.3019 48.7878 96.9034 48.2716V50.753H96.034V44.1964H96.8672V44.9571C97.2566 44.4228 97.8724 44.1512 98.5788 44.1512ZM98.5063 48.2897C99.43 48.2897 100.127 47.6196 100.127 46.5963C100.127 45.582 99.43 44.9119 98.5063 44.9119C97.5917 44.9119 96.8943 45.582 96.8943 46.5963C96.8943 47.6196 97.5917 48.2897 98.5063 48.2897ZM102.642 43.2727C102.307 43.2727 102.053 43.0282 102.053 42.7113C102.053 42.3943 102.307 42.1407 102.642 42.1407C102.977 42.1407 103.23 42.3852 103.23 42.6931C103.23 43.0192 102.986 43.2727 102.642 43.2727ZM102.207 48.9961V44.1964H103.076V48.9961H102.207ZM105.569 45.0024C105.877 44.4409 106.475 44.1512 107.317 44.1512V44.9934C107.245 44.9843 107.181 44.9843 107.118 44.9843C106.185 44.9843 105.606 45.5548 105.606 46.6053V48.9961H104.736V44.1964H105.569V45.0024ZM112.682 46.6234C112.682 46.6959 112.673 46.8045 112.664 46.8861H108.77C108.879 47.7283 109.558 48.2897 110.509 48.2897C111.07 48.2897 111.541 48.0996 111.894 47.7101L112.374 48.2716C111.94 48.7788 111.279 49.0504 110.482 49.0504C108.933 49.0504 107.901 48.0271 107.901 46.5963C107.901 45.1745 108.924 44.1512 110.31 44.1512C111.695 44.1512 112.682 45.1473 112.682 46.6234ZM110.31 44.8847C109.476 44.8847 108.861 45.4462 108.77 46.2612H111.849C111.759 45.4552 111.152 44.8847 110.31 44.8847ZM117.548 42.2766H118.417V48.9961H117.584V48.2354C117.195 48.7788 116.579 49.0504 115.873 49.0504C114.469 49.0504 113.446 48.0633 113.446 46.5963C113.446 45.1292 114.469 44.1512 115.873 44.1512C116.552 44.1512 117.15 44.4047 117.548 44.9209V42.2766ZM115.945 48.2897C116.86 48.2897 117.557 47.6196 117.557 46.5963C117.557 45.5729 116.86 44.9119 115.945 44.9119C115.021 44.9119 114.324 45.5729 114.324 46.5963C114.324 47.6196 115.021 48.2897 115.945 48.2897ZM120.108 46.9947L119.945 42.6569H120.968L120.796 46.9947H120.108ZM120.461 49.0504C120.117 49.0504 119.863 48.7878 119.863 48.4708C119.863 48.1448 120.117 47.8913 120.461 47.8913C120.796 47.8913 121.04 48.1448 121.04 48.4708C121.04 48.7878 120.796 49.0504 120.461 49.0504Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.303 146.964C210.303 146.964 199.19 183.004 202.172 194.523C202.172 194.523 200.164 195.523 193.659 194.506",
    stroke: "#666666",
    strokeWidth: 1.28948,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.33 150.081C223.33 150.081 229.268 171.697 230.784 179.642C231.792 184.927 229.725 194.667 229.725 194.667C229.725 194.667 237.907 193.829 239.237 194.684",
    stroke: "#666666",
    strokeWidth: 1.28948,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.43 130.456L227.904 131.252C228.514 132.285 229.996 132.319 230.657 131.311L236.899 121.842C236.899 121.842 242.117 122.663 244.946 117.844",
    stroke: "#666666",
    strokeWidth: 1.28948,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.494 130.464L204.019 131.261C203.401 132.286 201.927 132.319 201.267 131.32L195.041 121.842C195.041 121.842 189.815 122.647 187.003 117.827",
    stroke: "#666666",
    strokeWidth: 1.28948,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.545 157.289L227.819 157.213C230.547 156.722 231.114 156.129 231.902 155.299C235.518 151.513 222.508 111.94 222.508 111.94L209.973 112.025C209.973 112.025 197.505 151.767 201.172 155.502C201.968 156.315 202.544 156.908 205.28 157.357L216.545 157.289Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.925355,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.504 117.319C223.414 117.319 229.826 110.906 229.826 102.996C229.826 95.0854 223.414 88.6729 215.504 88.6729C207.593 88.6729 201.181 95.0854 201.181 102.996C201.181 110.906 207.593 117.319 215.504 117.319Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.925355,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.38 109.129C210.38 109.129 215.386 115.498 220.84 109.129H210.38Z",
    fill: "#F8D6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.43 130.456L227.904 131.252C228.514 132.285 229.996 132.319 230.657 131.311L236.899 121.842C236.899 121.842 242.117 122.663 244.946 117.844",
    stroke: "#666666",
    strokeWidth: 1.28948,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.494 130.464L204.019 131.261C203.401 132.286 201.927 132.319 201.267 131.32L195.041 121.842C195.041 121.842 189.815 122.647 187.003 117.827",
    stroke: "#666666",
    strokeWidth: 1.28948,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.545 157.289L227.819 157.213C230.547 156.722 231.114 156.129 231.902 155.299C235.518 151.513 222.508 111.94 222.508 111.94L209.973 112.025C209.973 112.025 197.505 151.767 201.172 155.502C201.968 156.315 202.544 156.908 205.28 157.357L216.545 157.289Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.925355,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.504 117.319C223.414 117.319 229.826 110.906 229.826 102.996C229.826 95.0854 223.414 88.6729 215.504 88.6729C207.593 88.6729 201.181 95.0854 201.181 102.996C201.181 110.906 207.593 117.319 215.504 117.319Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.925355,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.605 123.688L219.476 137.766L215.605 143.246",
    fill: "#F8D6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.605 124.781L212.649 138.071L215.605 143.246",
    fill: "#F8D6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.292 120.063L219.926 136.419L216.292 142.789",
    stroke: "#666666",
    strokeWidth: 0.925355,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.046 120.029L212.76 136.461L216.529 142.746",
    stroke: "#666666",
    strokeWidth: 0.925355,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.291 121.41C217.045 121.41 217.655 120.799 217.655 120.046C217.655 119.293 217.045 118.683 216.291 118.683C215.538 118.683 214.928 119.293 214.928 120.046C214.928 120.799 215.538 121.41 216.291 121.41Z",
    fill: "#F8D6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.292 121.411C217.298 121.411 218.113 120.595 218.113 119.59C218.113 118.584 217.298 117.769 216.292 117.769C215.286 117.769 214.471 118.584 214.471 119.59C214.471 120.595 215.286 121.411 216.292 121.411Z",
    stroke: "#666666",
    strokeWidth: 0.925355,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.38 109.129C210.38 109.129 215.386 115.498 220.84 109.129H210.38Z",
    fill: "#F8D6E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3086_290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 382,
    height: 200.741,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivatedSalesforce);
export default __webpack_public_path__ + "static/media/deactivated_salesforce.743fdb68e65d84ba57b591986af5a56d.svg";
export { ForwardRef as ReactComponent };